import React, { useMemo } from "react";
import _ from "lodash";

import { ViewLessonContent } from "./lesson";
import { ViewAssessmentContent } from "./assessment";
import { LearningRecordCourse } from "src/types/coaching/learners";

import styles from "./content.module.scss";
import { CourseContext } from "../../context";
import { Assessment } from "src/types/coaching/courses";

interface ViewCourseContentProps {
  course: LearningRecordCourse;
  collapsed: boolean;
}

export const ViewCourseContent: React.FC<ViewCourseContentProps> = ({course, collapsed}) => {
  const courseContext = React.useContext(CourseContext);
  const courseContent = courseContext.courseContent;
  
  const entityType = useMemo(() => {
    return _.get(courseContent, "entityType");
  }, [courseContent]);

  return (
    <div className={styles.content}>
      {courseContent && entityType === "lesson" && (
        <ViewLessonContent key={courseContent.id} course={course} lesson={courseContent} collapsed={collapsed}/>
      )}

      {courseContent && entityType === "assessment" && (
        <ViewAssessmentContent key={courseContent.id} course={course} assessment={courseContent as Assessment} collapsed={collapsed} />
      )}
    </div>
  );
}